export default {
  CustomerTitle: 'จัดการหน่วยงาน',
  buttonnewCustomer: 'เพิ่มหน่วยงาน',
  buttonnewCustomerDepartment: 'เพิ่มแผนก',
  buttonDeleteCustomer: 'ลบหน่วยงาน',
  buttonDeleteCustomerDepartment: 'ลบแผนก',
  newCustomer: 'เพิ่มหน่วยงาน',
  editCustomer: 'แก้ไขหน่วยงาน',
  newCustomerDepartment: 'เพิ่มแผนก',
  editCustomerDepartment: 'แก้ไขแผนก',
  CustomerName: 'ชื่อหน่วยงาน',
  confirmDelete: 'คุณต้องการที่จะลบหน่วยงาน {}?',
  confirmCustomerDepartmentDelete: 'คุณต้องการที่จะลบหน่วยงานภาษา {}?',
  confirmDeleteSelected: 'คุณต้องการที่จะลบหน่วยงานที่เลือก?',
  confirmCustomerDepartmentDeleteSelected: 'คุณต้องการที่จะลบแผนกที่เลือก?',
  progressMessageDelete: 'กำลังลบหน่วยงาน {}',
  progressMessageCustomerDepartmentDelete: 'กำลังลบแผนก {}',
  messageDeleteNotSelected: 'กรุณาเลือกหน่วยงานที่จะลบ',
  messageDeleteDepartmentNotSelected: 'กรุณาเลือกแผนกที่จะลบ',
  tabWindow: 'หน้าต่าง',
  tabDepartment: 'ภาษา',
  AddPicture: 'เพิ่มรูป',
  CustomerDetail: 'รายละเอียดหน่วยงาน',
  copyHeader: 'คัดลอกข้อมูลส่วนหัว',
}
